import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';

/**
 * Checks whether Time Panel feature is supported in current user/window context.
 *
 * This determines whether Time Panel can be shown. Features that interact with Time Panel
 * should instead call `isTimePanelAvailable`, which is a superset of this logic.
 */
export function isTimePanelSupported(): boolean {
    return (
        isFeatureEnabled('cal-time-panel') &&
        !getUserConfiguration().SessionSettings.IsShadowMailbox
    );
}
